var resolveURL = require('resolve-url');

var _require = require('../../package.json'),
    devDependencies = _require.devDependencies;
/*
 * Default options for browser environment
 */


module.exports = {
  corePath: typeof process !== 'undefined' && process.env.FFMPEG_ENV === 'development' ? resolveURL('/node_modules/@ffmpeg/core/dist/ffmpeg-core.js') : "https://unpkg.com/@ffmpeg/core@".concat(devDependencies['@ffmpeg/core'].substring(1), "/dist/ffmpeg-core.js")
};